import {GET_ASSESSMENT_LIST, GET_ASSESSMENT_LIST_SUCCESS, GET_ASSESSMENT_LIST_FAILED, 
    SEARCH_QUESTION_FROM_QUESTION_BANK,SEARCH_QUESTION_FROM_QUESTION_BANK_SUCCESS,SEARCH_QUESTION_FROM_QUESTION_BANK_FAIL,
    UPDATE_ACTIVITY_STATUS,UPDATE_ACTIVITY_STATUS_SUCCESS,UPDATE_ACTIVITY_STATUS_FAIL,
    GET_VIEW_ASSESSMENT_LIST, GET_VIEW_ASSESSMENT_LIST_SUCCESS ,GET_VIEW_ASSESSMENT_LIST_FAIL,
    POST_SELECTED_QUESTION,POST_SELECTED_QUESTION_SUCCESS, POST_SELECTED_QUESTION_FAIL, UPDATE_SELECTED_QUESTION
   } from "./actionTypes";
 
 /**
  * @module Admin Reports Reducer
  * @desc this Reducer help's us to maintain the Reports page api's data 
  * @return {Object} api's response
  */
 
   
   const initialState = {
     loader: false,
     assessmentList: null,
     errorMessage: null,
     //update assessment status
     success: null,
     errorMsg: null,
     //submit selected questions
     selectedQuestionMsg: null,
     selectederrormsg: null,
     assessmentlistloader:false
    
   };
   
   
 //    /** 
 //      * @property {function} reportIssueReducer function handels the reports reducer functionality
 //      * @param {object} initialState state 
 //      * @param {func} function current action
 //      *  @desc based upon the action the reducer will add or remove the data in the initialstate object 
 //      */
   const ManageAssessmentReducer = (state = initialState, action) => {
     switch (action.type) {
       case GET_ASSESSMENT_LIST:
         state = {
           ...state,
           loader: true,
           assessmentList: null,
           errorMessage: null
         };
         break;
       case GET_ASSESSMENT_LIST_SUCCESS:
         state = {
           ...state,
           loader: false,
           assessmentList: action.payload,
           errorMessage: null,
         };
         break;
       case GET_ASSESSMENT_LIST_FAILED:
         state = {
           ...state,
           loader: false,
           assessmentList: null,
           errorMessage: action.payload,
         };
         break;
       //view assessment
       case GET_VIEW_ASSESSMENT_LIST:
         state = {
           ...state,
           assessmentlistloader: true,
           viewAssessmentList: null,
         };
         break;
       case GET_VIEW_ASSESSMENT_LIST_SUCCESS:
         state = {
           ...state,
            assessmentlistloader: false,
           viewAssessmentList: action.payload
         };
         break;
       case GET_VIEW_ASSESSMENT_LIST_FAIL:
         state = {
           ...state,
            assessmentlistloader: false,
           viewAssessmentList: null
         };
         break;
         //update assesment status
         case UPDATE_ACTIVITY_STATUS:
           state = {
             ...state,
             assessmentlistloader: true,
             success: null,
             errorMsg: null,
           };
           break;
         case UPDATE_ACTIVITY_STATUS_SUCCESS:
           state = {
             ...state,
             assessmentlistloader: false,
             success: action.payload,
             errorMsg: null,
           };
           break;
         case UPDATE_ACTIVITY_STATUS_FAIL:
           state = {
             ...state,
             assessmentlistloader: false,
             success: null,
             errorMsg: action.payload,
           };
           break;
       //add assessment
       case SEARCH_QUESTION_FROM_QUESTION_BANK:
         state = {
           ...state,
           loader: true,
           assessmentQuestions:null
         };
         break;
       case SEARCH_QUESTION_FROM_QUESTION_BANK_SUCCESS:
         state = {
           ...state,
           loader: false,
           assessmentQuestions: action.payload
         };
         break;
       case SEARCH_QUESTION_FROM_QUESTION_BANK_FAIL:
         state = {
           ...state,
           loader: false,
           assessmentQuestions: null,
         };
         break;
         //submit selected questions
         case POST_SELECTED_QUESTION:
           state = {
             ...state,
             loader: true,
             selectedQuestionMsg: null,
             selectederrormsg: null,
           };
           break;
         case UPDATE_SELECTED_QUESTION:
           state = {
             ...state,
            //  loader: true,
             selectedQuestionMsg: null,
             selectederrormsg: null,
           };
           break;
 
         case  POST_SELECTED_QUESTION_SUCCESS:
           state = {
             ...state,
             loader: false,
             selectedQuestionMsg: action.payload,
             selectederrormsg: null,
           };
           break;
         case POST_SELECTED_QUESTION_FAIL:
           state = {
             ...state,
             loader: false,
             selectedQuestionMsg: null,
             selectederrormsg: action.payload,
           };
           break;
       
       default:
         state = { ...state };
         break;
     }
     return state;
   };
   export default ManageAssessmentReducer;
   